import LogService from '@/services/logService';

export const log = {
  namespaced: true,
  
  actions: {
    sendLogToBackend({ commit }: any, data: any) {
        return LogService.sendLogToBackend(data).then(
          (success: any) => {
            return Promise.resolve(success.data);
          },
          (error: any) => {
            alert("error");
    
            return Promise.reject(error);
          }
        );
      },           
  },
};

export default log;